import { useMutation } from 'urql';
import { PauseNewsletterDocument } from '@packages/gql/generated/shopping/PauseNewsletterDocument';

/* GraphQL */ `
  mutation PauseNewsletter($emailAddress: String!, $pauseDays: Int!) {
    changeNewsletterRecipient(
      pauseRequestData: { emailAddress: $emailAddress, pauseDays: $pauseDays }
    ) {
      ... on SubscribeResponseData {
        success
      }
      ... on ErrorResponse {
        errors
      }
    }
  }
`;

export const usePauseNewsletterGql = () => {
  const [, executeMutation] = useMutation(PauseNewsletterDocument);
  return executeMutation;
};
